export default {
  serviceOrders: 'Atividades',
  profile: 'Perfil',
  person: 'Pessoas',
  location: 'Locais',
  fleet: 'Frotas',
  users: 'Usuários',
  welcomeAssistant: 'Olá! Sou o assistente virtual da BTime. Como posso ajudar você hoje?',
  btimeAI: 'Btime AI',
  satisfactionSurvey: 'Pesquisa de Satisfação',
  chatSupport: 'Suporte via chat',
  dashboard: 'Dashboard',
  processes: 'Processos',
  map: 'Mapa',
  forms: 'Formulários',
  nonCompliance: 'Não conformidade',
  nonComplianceServiceOrders: 'Não conformidades de atividades',
  nonComplianceForms: 'Não conformidades de formulários',
  availability: 'Disponibilidade',
  dynamicServiceOrders: 'Atividades Dinâmicas',
  stocks: 'Estoque',
  settings: 'Configurações',
  generalRegistrations: 'Cadastros gerais',
  checklists: 'Questionários',
  masks: 'Máscaras',
  assets: 'Ativos',
  segmentation: 'Segmentação',
  integrations: 'Integrações',
  webhook: 'Webhook',
  modulesAndPermissions: 'Modulos e permissões',
  createPlaceType: 'Criar tipo de local',
  projects: 'Projetos',
  systemLogs: 'Logs do sistema',
  triggerHistory: 'Histórico de gatilhos',
  clearCache: 'Limpar cache',
  changePassword: 'Alterar senha',
  logout: 'Deslogar'
}
